import { api } from '../utils';

export const getTranslates = () => api('/translates', {}, 'GET', true);

export const getDefaultTranslates = () => api('/translates', {}, 'GET', true, '', 'en');
